<template>
  <button
      class="timesheet_button"
      :disabled="adminBusy"
      @click="run"
      type="button"
  >
    <span v-if="!adminBusy">{{ hard ? 'Force ' : '' }}Reset</span>
    <span v-else>Working...</span>
  </button>
</template>

<script>
import { canForceTimesheetAction, timesheetActionError, TIMESHEET_ACTION_ERROR_TOAST } from "pages/sunset/timesheets/components/shared";

export default {
  name: "AdminResetTimesheetButton",

  props: {
    companyId: { required: true },
    timesheetId: { required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    success: { type: Function, required: true }
  },

  computed: {
    // The permission decides, not the caller - permitted users only ever get the hard reset,
    // everyone else only ever gets the soft one.
    hard: canForceTimesheetAction
  },

  methods: {
    async doAction() {
      let url = `${this.crmApiPath}r3/admin/timesheets/company/${this.companyId}/reset/timesheet/${this.timesheetId}`;
      if (this.hard) {
        url += '?skip_fin=false';
      }
      await axios.post(url);
      this.$snotify?.success("Timesheet reset!");
    },

    async run() {
      try {
        await this.withAdminLock(this.doAction)();
      } catch (e) {
        // Show the API's reason (e.g. already submitted to finance - escalate) and do not
        // refresh, so the message stays on screen.
        this.$snotify?.error(
            timesheetActionError(e, 'Reset failed. Please try again.'),
            TIMESHEET_ACTION_ERROR_TOAST
        );
        return;
      }

      await this.success();
    }
  }
};
</script>
